<template>
  <div :style="theme" class="router_box" id="routerBox">
    <ReleaseTicker v-if="showReleaseTicker"/>
    <router-view :key="routerViewKey"/>
  </div>
</template>

<script>
import storage from '@/fetch/storage'
import ReleaseTicker from '@/components/ReleaseTicker/index.vue'

export default {
  name: 'App',
  components: {
    ReleaseTicker
  },
  computed: {
    routerViewKey() {
      return `${this.$route.fullPath}:${this.$store.state.machineGroupScopeVersion}`
    },
    showReleaseTicker() {
      const path = String(this.$route && this.$route.path || '')
      return !!storage.get('token')
        && !path.startsWith('/bigscreen/')
        && !path.includes('/login')
        && !path.includes('/downloadPdf')
    }
  },
  mounted() {
    let color = JSON.parse(localStorage.getItem('bg'))
    let body = document.getElementById('body')
    let bg = '--nav-bg'
    body.style = bg + ':' + color
    this.$tool.screenZoom()
  }
}
</script>

<style lang="scss">
@import "../public/static/css/reset.css";
@import "../public/static/css/index.scss";
@import "../public/static/css/table.scss";
@import "../public/static/css/home.scss";
@import "./common/font/font.css";
@import "../public/static/css/root.scss";

.router_box{
  height: 100vh;
  min-height: 100dvh;
  position: relative;

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 80%, rgba(0, 212, 255, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(0, 153, 204, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba(30, 60, 114, 0.2) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
}
@font-face {
  font-family: 'font2'; /* 字体名称 */
  src: url('../public/static/css/font/font2.otf') format('truetype'); /* 字体文件路径和格式 */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s; /* 定义过渡效果的持续时间和类型 */
}

.fade-enter, .fade-leave-to {
  opacity: 0; /* 初始状态和结束状态 */
}

div,
span {
  font-family: PingFang,Inte;
}

.table-search {
  //padding: 1.851vh 0 10px;
}

.table-arrange-active {
  cursor: pointer;
  color: rgb(23, 144, 255);
}

.el-input__inner:focus {
  border-color: #B6BFCF !important;
}

.el-message-box{
  .el-button--primary{
    background: #4D648D;
  }
  .el-button--primary:hover{
    background: #4D648D;
  }
}

html,body{
  font-family:
      -apple-system,           /* macOS 首选 */
      "Segoe UI",              /* Windows 首选 */
      Roboto,                  /* Linux/Android 常见 */
      "Helvetica Neue",        /* 通用无衬线 */
      Arial,                   /* 最广泛支持的备选 */
      "Noto Sans",             /* Linux 通用字体 */
      sans-serif;              /* 最终回退到系统无衬线 */
}
</style>
